module.exports = __webpack_public_path__ + "static/media/26.3dacac6c.wav";